export default __webpack_public_path__ + "images/5356e2289cf282d806ae163d4db3fd21.png";